// src/utils/rsaUtils.ts
import { IEncryptedPayload } from '@/types/common/encryption';
import forge from 'node-forge';

export interface RSAKeyPair {
  publicKey: string;  // PEM-encoded public key
  privateKey: string; // PEM-encoded private key
}

const RSAUtils = {
  checkPublicKeySize(publicKey: string): number {
    const publicKeyObject = forge.pki.publicKeyFromPem(publicKey.trim());
    return publicKeyObject.n.bitLength();
  },

  /**
   * Encrypt a UTF-8 string using the provided public key (PEM).
   * @param publicKeyPem - PEM-encoded public key
   * @param message - UTF-8 plaintext message
   * @returns Base64-encoded encrypted string
   */
  encrypt(message: string, publicKeyPem: string): string {


    const publicKey = forge.pki.publicKeyFromPem(publicKeyPem.trim());
    const encrypted = publicKey.encrypt(forge.util.encodeUtf8(message), 'RSA-OAEP');
    return forge.util.encode64(encrypted);
  },

  /**
   * Decrypt a Base64-encoded string using the provided private key (PEM).
   * @param privateKeyPem - PEM-encoded private key
   * @param encryptedBase64 - Base64-encoded ciphertext
   * @returns Decrypted UTF-8 plaintext string
   */
  decrypt(encryptedBase64: string, privateKeyPem: string): string {
    const privateKey = forge.pki.privateKeyFromPem(privateKeyPem.trim());
    const decrypted = privateKey.decrypt(forge.util.decode64(encryptedBase64), 'RSA-OAEP');
    return forge.util.decodeUtf8(decrypted);
  },

  encryptRequestBody2Payloads(body: unknown, publicKey: string): IEncryptedPayload {
    const rawBody: string = JSON.stringify(body);
    const keyLength: number = this.checkPublicKeySize(publicKey);

    const maxCharacters = keyLength / 8 / 4;
    const encrypted_payloads = [];
    for (let i = 0; i < rawBody.length; i += maxCharacters) {
      const chunk = rawBody.slice(i, i + maxCharacters);
      encrypted_payloads.push(this.encrypt(chunk, publicKey));
    }

    return {
      encrypt_status: true,
      payloads: encrypted_payloads
    };
  },
};

export default RSAUtils;
